<template>
  <div class="modal-viewer">
    <div class="modal-viewer__head modal-p-lr-35 display-flex-center justify-content-between">
      <div class="inner-back js-back" @click="turnOffModal">
        <span class="icon-arrow-left font-size-16 color-light position-rel"><span class="path1"></span><span class="path2"></span></span>
      </div>
      <h2 class="modal-viewer__title font-size-16 font-sanpro-light color-light display-flex-center">
        <span v-if="mediaPreviewData && mediaPreviewData[indexPreviewMedia] && mediaPreviewData[indexPreviewMedia].linkUrl && checkVideo(mediaPreviewData[indexPreviewMedia].linkUrl)" class="icon-lesson-video"><span class="path1"></span><span class="path2"></span></span>
        <i v-else-if="mediaPreviewData && mediaPreviewData[indexPreviewMedia] && mediaPreviewData[indexPreviewMedia].linkUrl && checkImage(mediaPreviewData[indexPreviewMedia].linkUrl)" class="icon-lesson--picture"></i>
        <i v-else-if="mediaPreviewData && mediaPreviewData[indexPreviewMedia] && mediaPreviewData[indexPreviewMedia].linkUrl && checkAudio(mediaPreviewData[indexPreviewMedia].linkUrl)" class="icon-lesson-audio"></i>
        {{ mediaPreviewData && mediaPreviewData[indexPreviewMedia] && mediaPreviewData[indexPreviewMedia].title ? mediaPreviewData[indexPreviewMedia].title : '' }}
      </h2>
      <a
        href="javascript:;"
        class="btn btn-main font-size-16 border-rd-20 display-flex-center justify-content-center modal-viewer__use-btn"
        @click="handleUseMedia()"
      >
        Sử dụng
      </a>
    </div>
    <div class="modal-viewer__body position-rel display-flex-center">
      <!-- <div class="overlay"></div> -->
      <div class="modal-viewer__main modal-viewer__main--slide modal-p-lr-35 position-rel display-flex-center justify-content-between">
        <div class="modal-viewer__prev cursor-pointer"><i class="icon-back font-size-36 color-light"></i></div>
        <swiper :options="optionsSliderMain" ref="swiper_slide_preview" class="modal-viewer__swiper">
          <swiperSlide 
            class="item position-rel text-center margin-0 p-0" 
            v-for="(item, index) of mediaPreviewData" 
            :key="index"
          >
            <PreviewVideo
              v-if="item.linkUrl && checkVideo(item.linkUrl)"
              :pathView="`${appUrl}${item.linkUrl}`"
            />
            <PreviewAudioPoster
              v-else-if="item.linkUrl && checkAudio(item.linkUrl)"
              :pathView="`${appUrl}${item.linkUrl}`"
              :autoPlay="false"
              :poster="imgThumbAudio"
            />
            <img 
              v-else-if="item.linkUrl && (checkImage(item.linkUrl) || checkGifImage(item.linkUrl))"
              :src="`${appUrl}${item.linkUrl}`"
            >
          </swiperSlide>
        </swiper>
        <div class="modal-viewer__next cursor-pointer"><i class="icon-next1 font-size-36 color-light"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { APP_CONFIG } from '@/utils/constants'
import { STORE_KEY } from './../../_store/constants'
import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
import PreviewAudioPoster from '@/components/content-files/PreviewAudioPoster.vue'
import mixinsFiles from '@/components/content-files/mixinsFiles'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'

const imgThumbAudio = require(`@/assets/images/thumb-audio.png`)

export default {
  name: 'ModalPreviewMedia',
  mixins: [ mixinsFiles, mixinsDetailLesson ],
  components: {
    swiper,
    swiperSlide,
    PreviewVideo,
    PreviewAudioPoster
  },
  data () {
    return {
      optionsSliderMain: this.settingSwiperMain(),
      imgThumbAudio,
      appUrl: APP_CONFIG.bookCdnUrl
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['mediaPreviewData', 'indexPreviewMedia', 'paramsSearchMediaDetail', 'keySidebarActive']),
    swiper () {
      return this.$refs.swiper_slide_preview.swiper
    }
  },
  watch: {
    keySidebarActive (newVal) {
      this.acSetMediaPreview([])
    }
  },
  mounted () {
    this.indexPreviewMedia > 0 && this.swiper.slideTo(this.indexPreviewMedia, 500, false)
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetMediaPreview', 'acSetPreviewModalVisibleIndex', 'acSetParamSearchMediaDetail']),

    turnOffModal () {
      this.acSetPreviewModalVisibleIndex(-1)
    },

    settingSwiperMain() {
      let self = this;
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.modal-viewer__next',
          prevEl: '.modal-viewer__prev',
        },
        on: {
          slideChange: function () {
            self.acSetPreviewModalVisibleIndex(this.realIndex)
          }
        }
      }
    },

    handleUseMedia () {
      if (this.indexPreviewMedia === -1 || !this.mediaPreviewData || !this.mediaPreviewData[this.indexPreviewMedia] || !this.mediaPreviewData[this.indexPreviewMedia].linkUrl) {
        return
      }
      let data = this.mediaPreviewData[this.indexPreviewMedia]
      let linkData = data.linkUrl
      if (this.checkVideo(linkData)) {
        this.addVideo(data)
      } else if (this.checkImage(linkData)) {
        this.addImageUrl(`${this.appUrl}/${linkData}`)
      } else if (this.checkAudio(linkData)) {
        this.addAudio(data)
      }
      this.turnOffModal()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>